
(() => {
  'use strict';
  const flash=document.querySelector('[data-atrato-flash]');
  if(!flash)return;
  const KEY='elevenine-atrato-finance-seen-v3';
  let seen=false;
  try{seen=sessionStorage.getItem(KEY)==='1'}catch{}
  const remember=()=>{try{sessionStorage.setItem(KEY,'1')}catch{}};
  const close=()=>{
    if(!flash.classList.contains('is-visible'))return;
    remember();
    flash.classList.remove('is-visible');
    document.documentElement.classList.remove('atrato-flash-open');
    setTimeout(()=>{flash.hidden=true},340);
  };
  const open=()=>{
    if(seen)return;
    flash.hidden=false;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      flash.classList.add('is-visible');
      document.documentElement.classList.add('atrato-flash-open');
      flash.querySelector('[data-atrato-close]')?.focus({preventScroll:true});
    }));
  };
  flash.querySelectorAll('[data-atrato-close]').forEach(el=>el.addEventListener('click',close));
  flash.querySelector('[data-atrato-cta]')?.addEventListener('click',remember);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  setTimeout(open,1700);
})();
